import {
    MAIL_MERGE_FIELDS,
    TEXT_CASE_OPTIONS,
    TextCase,
    buildMergeToken,
} from "@app/utils/MailMergeFields";

const CASE_ATTRIBUTE = 'data-text-case';

const mergeTag = {
    // @Required
    // plugin name
    name: 'select_fields',

    // @Required
    // data display
    display: 'submenu',

    // @Required
    // add function - It is called only once when the plugin is first run.
    // This function generates HTML to append and register the event.
    // arguments - (core : core object, targetElement : clicked button element)
    add: function (core, targetElement) {

        // Generate submenu HTML
        // Always bind "core" when calling a plugin function
        let listDiv = this.setSubmenu.call(core);

        // You must bind "core" object when registering an event.
        /** add event listeners */
        let self = this;
        listDiv.querySelectorAll('.se-btn-case').forEach(function (btn) {
            btn.addEventListener('click', self.onClickTextCase.bind(core));
        });
        listDiv.querySelectorAll('.se-btn-list').forEach(function (btn) {
            btn.addEventListener('click', self.onClick.bind(core));
        });

        // @Required
        // You must add the "submenu" element using the "core.initMenuTarget" method.
        /** append target button menu */
        core.initMenuTarget(this.name, targetElement, listDiv);
    },

    setSubmenu: function () {
        const listDiv = this.util.createElement('DIV');
        // @Required
        // A "se-submenu" class is required for the top level element.
        listDiv.className = 'se-submenu se-list-layer se-merge-tag-layer';
        // Kiểu chữ đang chọn được giữ ngay trên layer, mỗi editor có state riêng.
        listDiv.setAttribute(CASE_ATTRIBUTE, TextCase.KEEP);

        const caseButtons = TEXT_CASE_OPTIONS.map((option, index) => (
            `<button type="button" class="se-btn-case${index === 0 ? ' active' : ''}"
                     ${CASE_ATTRIBUTE}="${option.value}">${option.label}</button>`
        )).join('');

        const fieldButtons = MAIL_MERGE_FIELDS.map((field) => (
            `<li><button type="button" class="se-btn-list" data-label="${field.label}">${field.label}</button></li>`
        )).join('');

        listDiv.innerHTML = `<div class="se-list-inner se-list-font-size">
            <div class="se-merge-case-picker">
                <span class="se-merge-case-title">Kiểu chữ khi fill giá trị</span>
                <div class="se-merge-case-group">${caseButtons}</div>
            </div>
            <ul class="se-list-basic btn btn-primary" style="width: auto; background: none">${fieldButtons}</ul>
            </div>`

        return listDiv;
    },

    /** Chọn kiểu chữ — chỉ đổi state, KHÔNG đóng submenu để user chọn tiếp field. */
    onClickTextCase: function (e) {
        e.preventDefault();
        e.stopPropagation();

        const button = e.target.closest('.se-btn-case');
        if (!button) return;

        const layer = button.closest('.se-merge-tag-layer');
        if (!layer) return;

        layer.setAttribute(CASE_ATTRIBUTE, button.getAttribute(CASE_ATTRIBUTE) || TextCase.KEEP);
        layer.querySelectorAll('.se-btn-case').forEach(function (item) {
            item.classList.remove('active');
        });
        button.classList.add('active');
    },

    onClick: function (e) {
        const button = e.target.closest('.se-btn-list');
        if (!button) return;

        const layer = button.closest('.se-merge-tag-layer');
        const textCase = layer ? (layer.getAttribute(CASE_ATTRIBUTE) || TextCase.KEEP) : TextCase.KEEP;
        const value = buildMergeToken(button.getAttribute('data-label'), textCase);

        const node = this.util.createElement('span');
        this.util.addClass(node, 'se-custom-tag');
        node.textContent = value;

        this.insertNode(node);
        const zeroWidthSpace = this.util.createTextNode(this.util.zeroWidthSpace);
        node.parentNode.insertBefore(zeroWidthSpace, node.nextSibling);

        // Record history and trigger onChange callback
        this.history.push(false);

        this.submenuOff();
    }
};

export default mergeTag
